import React from "react";

import { Icon, IconProps } from "../";

export const TrainIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,1626 C96,1626 92,1626.5 92,1630 L92,1639.5 C92,1641.43 93.57,1643 95.5,1643 L94.35,1644.15 C94.04,1644.46 94.26,1645 94.71,1645 L95.8,1645 C95.93,1645 96.06,1644.95 96.15,1644.85 L98,1643 L102,1643 L103.85,1644.85 C103.94,1644.94 104.07,1645 104.2,1645 L105.29,1645 C105.74,1645 105.96,1644.46 105.64,1644.15 L104.5,1643 C106.43,1643 108,1641.43 108,1639.5 L108,1630 C108,1626.5 104,1626 100,1626 Z M95.5,1641 C94.67,1641 94,1640.33 94,1639.5 C94,1638.67 94.67,1638 95.5,1638 C96.33,1638 97,1638.67 97,1639.5 C97,1640.33 96.33,1641 95.5,1641 Z M99,1634 L94,1634 L94,1630 L99,1630 L99,1634 Z M104.5,1641 C103.67,1641 103,1640.33 103,1639.5 C103,1638.67 103.67,1638 104.5,1638 C105.33,1638 106,1638.67 106,1639.5 C106,1640.33 105.33,1641 104.5,1641 Z M106,1634 L101,1634 L101,1630 L106,1630 L106,1634 Z"
        transform="translate(-88 -1624)"
      />
    </Icon>
  );
};
